/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { ImportResults } from './ImportResults';
import {
  ImportResultsFromJSON,
  ImportResultsFromJSONTyped,
  ImportResultsToJSON,
} from './ImportResults';

/**
 *
 * @export
 * @interface PhoneCsvPatch
 */
export interface PhoneCsvPatch {
  /**
   * Start the import process with action=import
   * @type {string}
   * @memberof PhoneCsvPatch
   */
  action?: PhoneCsvPatchActionEnum;
  /**
   *
   * @type {ImportResults}
   * @memberof PhoneCsvPatch
   */
  importResults?: ImportResults;
  /**
   *
   * @type {Array<any>}
   * @memberof PhoneCsvPatch
   */
  labels?: Array<any>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof PhoneCsvPatch
   */
  mapping?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof PhoneCsvPatch
   */
  name?: string;
}

/**
 * @export
 */
export const PhoneCsvPatchActionEnum = {
  Import: 'import',
} as const;
export type PhoneCsvPatchActionEnum =
  (typeof PhoneCsvPatchActionEnum)[keyof typeof PhoneCsvPatchActionEnum];

/**
 * @export
 */
export const PhoneCsvPatchMappingEnum = {
  E164: 'e164',
  Dnc: 'dnc',
  DncScope: 'dnc_scope',
  DncExpiration: 'dnc_expiration',
  Dnt: 'dnt',
  DntScope: 'dnt_scope',
  DntExpiration: 'dnt_expiration',
  Consent: 'consent',
  Validity: 'validity',
  DoNotImport: 'do_not_import',
} as const;
export type PhoneCsvPatchMappingEnum =
  (typeof PhoneCsvPatchMappingEnum)[keyof typeof PhoneCsvPatchMappingEnum];

/**
 * Check if a given object implements the PhoneCsvPatch interface.
 */
export function instanceOfPhoneCsvPatch(value: object): value is PhoneCsvPatch {
  return true;
}

export function PhoneCsvPatchFromJSON(json: any): PhoneCsvPatch {
  return PhoneCsvPatchFromJSONTyped(json, false);
}

export function PhoneCsvPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PhoneCsvPatch {
  if (json == null) {
    return json;
  }
  return {
    action: json['action'] == null ? undefined : json['action'],
    importResults:
      json['import_results'] == null
        ? undefined
        : ImportResultsFromJSON(json['import_results']),
    labels: json['labels'] == null ? undefined : json['labels'],
    mapping: json['mapping'] == null ? undefined : json['mapping'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function PhoneCsvPatchToJSON(value?: PhoneCsvPatch | null): any {
  if (value == null) {
    return value;
  }
  return {
    action: value['action'],
    import_results: ImportResultsToJSON(value['importResults']),
    labels: value['labels'],
    mapping: value['mapping'],
    name: value['name'],
  };
}
